import { NavRoute } from '../../shared/navigation/nav.route.interface';

export const getEventsNav: () => NavRoute = () => {
	return {
		name: 'Dispense Events'
		, security: s => s.coreFeatures
		, path: 'events/dispense-event-list'
	};
};
